import React from 'react';

import PropTypes from 'prop-types';

import { PromoButton } from 'apps/promo/components/common/promo-button/PromoButton';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';
import PromoInputPartnerCode from 'apps/promo/components/form/PromoInputPartnerCode';
import PromoInputPhoneWithDropdown from 'apps/promo/components/form/PromoInputPhoneWithDropdown/PromoInputPhoneWithDropdown';
import Form from 'apps/promo/components/form-multi/Form';
import { NO_AUTH_LOGIN_REGISTRATION_FORM_NAME } from 'apps/promo/constants/formName';

export const HeroExtraBlock = (props) => {
    return (
        <Form formName={NO_AUTH_LOGIN_REGISTRATION_FORM_NAME}>
            {props.extraBlockTitle && (
                <PromoRow indent={'adaptive-24-32'} textAlign={'center'}>
                    <PromoText variant="subheader">{props.extraBlockTitle}</PromoText>
                </PromoRow>
            )}
            <PromoRow indent={'adaptive-24-32'}>
                <PromoInputPhoneWithDropdown
                    countries={props.countries}
                    currentCountry={props.currentCountry}
                    labelText={props.labelText}
                    searchPlaceholder={props.searchPlaceholder}
                    searchFullPlaceholder={props.searchFullPlaceholder}
                    searchModalTitle={props.searchModalTitle}
                    searchNoResult={props.searchNoResult}
                    isNonEditableCountry={props.isNonEditableCountry}
                />
            </PromoRow>
            {props.partnerCodeInputTitle && (
                <PromoRow indent={'adaptive-24-32'}>
                    <PromoInputPartnerCode labelText={props.partnerCodeInputTitle} hintText={props.partnerCodeInputHint} name={'partner_code_hero'} />
                </PromoRow>
            )}
            {props.btnTitle && (
                <PromoRow textAlign={'center'} indent={props.btnSecondaryTitle ? '8px' : null}>
                    <PromoButton
                        type={'button'}
                        onClick={props.onExtraButtonClick}
                        onKeyPress={props.onExtraButtonClick}
                        caption={props.btnTitle}
                        variant={props.btnVariant}
                        id={'acceptInviteBtn'}
                        disabled={props.disabledBtn}
                    />
                </PromoRow>
            )}
            {props.btnSecondaryTitle && (
                <PromoRow textAlign={'center'}>
                    <PromoButton
                        type={'button'}
                        onClick={props.onExtraSecondaryButtonClick}
                        onKeyPress={props.onExtraSecondaryButtonClick}
                        caption={props.btnSecondaryTitle}
                        variant={'secondary'}
                    />
                </PromoRow>
            )}
        </Form>
    );
};

HeroExtraBlock.propTypes = {
    labelText: PropTypes.string,
    btnTitle: PropTypes.string,
    btnVariant: PropTypes.string,
    onExtraButtonClick: PropTypes.func,
    disabledBtn: PropTypes.bool,
    extraBlockTitle: PropTypes.string,
    partnerCodeInputTitle: PropTypes.string,
    onExtraSecondaryButtonClick: PropTypes.func,
    btnSecondaryTitle: PropTypes.string,
};
